import { useState } from "react";
import { useLoad } from "@/lib/hooks";
import { fmt } from "@/lib/api";
import { Section, StatCard, EmptyRow } from "@/components/common";
import { PeriodFilter, monthStart, today, qs } from "./common";

const Rows = ({ rows, cur }) => rows?.map((r) => <tr key={r.code}><td><span className="mr-2 font-mono text-xs text-slate-400">{r.code}</span>{r.name}</td><td className="po-num">{fmt(r.amount, cur)}</td></tr>);

export default function Overview({ lk }) {
  const [p, setP] = useState({ frm: monthStart(), to: today() });
  const [pl] = useLoad(`/acct/profit-loss?${qs(p)}`);
  const [tb] = useLoad(`/acct/trial-balance?${qs({ to: p.to })}`);
  const cur = lk.currency;
  return (
    <>
      <div className="po-card flex flex-col gap-3 p-4 sm:flex-row sm:items-end sm:justify-between" data-testid="acct-period-bar">
        <div><div className="po-card-title">Reporting period</div><p className="text-xs text-slate-500">Profit &amp; loss uses the range; trial balance is as at the end date.</p></div>
        <PeriodFilter p={p} setP={setP} testId="pl-period" />
      </div>
      {pl && <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <StatCard testId="pl-income" tone="success" label="Income (period)" value={fmt(pl.total_income, cur)} />
        <StatCard testId="pl-expenses" tone="warning" label="Expenses (period)" value={fmt(pl.total_expenses, cur)} />
        <StatCard testId="pl-net" tone={pl.net_profit < 0 ? "danger" : "success"} label="Net profit" value={fmt(pl.net_profit, cur)} />
      </div>}
      <div className="grid gap-6 lg:grid-cols-2">
        <Section title="Profit & loss">
          <div className="overflow-x-auto"><table className="po-table" data-testid="pl-table">
            <thead><tr><th>Account</th><th className="po-num">Amount</th></tr></thead>
            <tbody>
              <tr className="po-subhead"><td colSpan={2}>Income</td></tr>
              <Rows rows={pl?.income} cur={cur} />
              <tr className="po-total"><td>Total income</td><td className="po-num">{fmt(pl?.total_income, cur)}</td></tr>
              <tr className="po-subhead"><td colSpan={2}>Expenses</td></tr>
              <Rows rows={pl?.expenses} cur={cur} />
              <tr className="po-total"><td>Total expenses</td><td className="po-num">{fmt(pl?.total_expenses, cur)}</td></tr>
              {pl && <tr className="po-total"><td>Net profit</td><td className={`po-num ${pl.net_profit < 0 ? "text-rose-600" : "text-emerald-700"}`}>{fmt(pl.net_profit, cur)}</td></tr>}
            </tbody>
          </table></div>
        </Section>
        <Section title={`Trial balance as at ${p.to}`}>
          <div className="overflow-x-auto"><table className="po-table max-sm:text-xs max-sm:[&_td]:px-2 max-sm:[&_th]:px-2" data-testid="trial-balance-table">
            <thead><tr><th>Account</th><th className="po-num">Debit</th><th className="po-num">Credit</th></tr></thead>
            <tbody>{tb?.rows.length === 0 && <EmptyRow cols={3} />}{tb?.rows.map((r) => (
              <tr key={r.code}><td><span className="mr-2 font-mono text-xs text-slate-400">{r.code}</span>{r.name}</td><td className="po-num whitespace-nowrap">{r.balance > 0 ? fmt(r.balance, cur) : ""}</td><td className="po-num whitespace-nowrap">{r.balance < 0 ? fmt(-r.balance, cur) : ""}</td></tr>))}
              {tb && <tr className="po-total"><td>Totals</td><td className="po-num whitespace-nowrap" data-testid="tb-total-debit">{fmt(tb.total_debit, cur)}</td><td className="po-num whitespace-nowrap" data-testid="tb-total-credit">{fmt(tb.total_credit, cur)}</td></tr>}
            </tbody>
          </table></div>
        </Section>
      </div>
    </>
  );
}
